import { Element, useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import RichText from "@/components/editor/primitives/rich-text";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";

import { PaddingWrapper } from "./rich-text-section-component-styles";

export default function RichTextSection() {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <Element
            id="rich-text-section"
            is={RichText}
            text="<h3 style='text-align:center;'>Join our first digital conference.</h3><p style='text-align:center;'>We’re here to help shape the future in a sustainable way. Our team is made of experts that help companies invest in renewable energy, and we support many initiatives to make the food industry more sustainable for our planet.</p><p style='text-align:center;'>You’ll be looking at the world through the eyes of some of the brightest minds around, and you’ll get a glimpse of<br>what our future might look like. Ready to ride?</p><figure class='image ck-widget ck-widget_with-resizer image-style-align-left' contenteditable='false'><img alt src=https://user-images.githubusercontent.com/6705361/127633727-4d775fbd-ac2d-4ff3-9673-78ced6b54451.jpg></img></figure><p></p><h4 style='text-align:center;'>Join our first digital conference.</h4><ul><li>10 technologies that will transform the global economy by 2025</li><li>The key to surviving this new industrial revolution is leading it. That requires two key elements of agile businesses.</li><li>Learn what it takes to hire and inspire your talent with an employee-centric organizational model. Get our free guide: 5 keys to successful organizational design </li><li>Earth is the third planet from the Sun and the only astronomical object known to harbor life.</li></ul>"
          />
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

RichTextSection.craft = {
  custom: {
    displayName: "Rich text section",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
